import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {ErrorToast, SuccessToast} from "../../shared/toasters/toasters";
import {AdminBrandCategoryService} from "./service";
import {CreateForm} from "./components/CreateForm";
import {useTranslation} from "react-i18next";
import DraggableBootstrapTable from "../../shared/components/draggableList/Draggable";
import {IBrandCategory} from "./interface";
import {Pagination} from "../../shared/paginations/Paginations";

export const AdminBrandCategory = () => {
    const {t} = useTranslation();
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 25,
        term: ""
    });
    const [isMenuOpened, setIsMenuOpened] = useState(false);
    const [state, setState] = useState<IBrandCategory | null>(null);
    const [list, setList] = useState<IBrandCategory[]>([]);
    const [image, setImage] = useState<File | null>(null);
    const handlePages = (updatePage: number) => {
        setPagination({...pagination, page: updatePage});
        setPage(updatePage);
    };
    const updatePosition = (newList: IBrandCategory[]) => {
        const newListUpdated = newList?.map((item) => item.id) as number[];
        AdminBrandCategoryService.updatePosition(newListUpdated);
    };

    const deleteHandler = () => {
        state?.id &&
        AdminBrandCategoryService.delete(state?.id)
            .then((response) => {
                if (response?.status === "success") {
                    SuccessToast(t(`brand_cat.successfully_deleted`));
                    setPagination(prev => ({...prev, updatedAt: new Date()?.getTime()}))
                }
            })
            .catch(ErrorToast);
    };

    const editHandler = (brandId: number) => {
        setIsMenuOpened(true);
        AdminBrandCategoryService.getSingle(brandId)
            .then((response) => {
                const {data} = response;
                setState(data);
                window.scrollTo(0, 0);
            })
            .catch(ErrorToast);
    };
    const submitHandler = () => {
        const formData = new FormData();
        formData.append("body", JSON.stringify(state));
        image && formData.append("file", image);
        if (state?.id) {
            AdminBrandCategoryService.update(formData, state.id)
                .then(() => {
                    SuccessToast(t(`brand_cat.successfully_updated`));
                    setIsMenuOpened(false);
                    setPagination(prev => ({...prev, updatedAt: new Date()?.getTime()}))
                    setState(null);
                })
                .catch(ErrorToast);
        } else {
            AdminBrandCategoryService.create(formData)
                .then(() => {
                    SuccessToast(t(`brand_cat.successfully_created`));
                    setIsMenuOpened(false);
                    setPagination(prev => ({...prev, updatedAt: new Date()?.getTime()}))
                    setState(null);
                })
                .catch(ErrorToast);
        }
    };
    useEffect(() => {
        AdminBrandCategoryService.getAll({perPage: 0, page: 1})
            .then((response) => {
                const {data} = response;
                setList(data?.items);
                setTotalPages(Math.ceil(data?.totalItems / data?.perPage));
            })
            .catch(ErrorToast);
    }, [pagination]);
    return (
        <>
            {!isMenuOpened && (
                <div className="col-12">
                    <div className="card">
                        <div className="card-body d-flex align-items-center justify-content-between">
                            <h4 className="card-title mg-b-0">
                                {t("brand.create_new_brand_cat")}
                            </h4>
                            <button
                                className="btn btn-primary"
                                onClick={() => setIsMenuOpened(true)}
                            >
                                {t("global.add")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isMenuOpened && (
                <div className="col-12">
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault();
                            submitHandler();
                        }}
                    >
                        <CreateForm
                            setIsMenuOpened={setIsMenuOpened}
                            state={state}
                            setState={setState}
                            setImage={setImage}
                        />
                    </Form>
                </div>
            )}
            <div className="col-12">
                <DraggableBootstrapTable
                    list={list}
                    preview={true}
                    setList={setList}
                    headers={["id", "title", "active"]}
                    title="category"
                    onEdit={editHandler}
                    selectedPrompt={state}
                    setSelectedPrompt={setState}
                    handleShow={handleShow}
                    show={show}
                    setShow={setShow}
                    deleteHandler={deleteHandler}
                    updatePosition={updatePosition}
                />
            </div>
            {page && (
                <div className="d-flex justify-content-end">
                    {totalPages <= 1 ? (
                        ""
                    ) : (
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            handlePagination={handlePages}
                        />
                    )}
                </div>
            )}
        </>
    );
};
